import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedProfilApiService } from './profil-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class ProfilApiService extends GeneratedProfilApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
